import { getSettingsEditing } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import React, { useMemo } from 'react'
import {
  FormCheckboxInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { BaseEditorCheckbox } from '../base-editor-checkbox'
import { FormBaseSubEntity } from './form-base-sub-entity'
import { useUpdateFormSubEntityProps } from './hooks/use-update-form-sub-entity-prop'

interface FormCheckboxSubEntityProps {
  formEntity: FormInterface
  checkboxSubEntity: FormCheckboxInterface
}

export const FormCheckboxSubEntity = ({
  formEntity,
  checkboxSubEntity,
}: FormCheckboxSubEntityProps) => {
  const entity = useMemo(
    () => ({
      ...checkboxSubEntity,
      ...formEntity.checkboxesCommonStyles,
    }),
    [checkboxSubEntity, formEntity.checkboxesCommonStyles],
  )

  const editingFormSubEntityId = useManagement(getSettingsEditing).subEntityId

  const updateProps = useUpdateFormSubEntityProps(formEntity, checkboxSubEntity)
  return (
    <FormBaseSubEntity
      formEntity={formEntity}
      subEntity={checkboxSubEntity}
      title={'entity_settings.checkbox.header'}
    >
      <BaseEditorCheckbox
        entityOrSubEntity={entity}
        isEditing={editingFormSubEntityId === checkboxSubEntity.id}
        checked={false}
        // biome-ignore lint/suspicious/noEmptyBlockStatements: <explanation>
        onChange={() => {}}
        updateText={updateProps}
      />
    </FormBaseSubEntity>
  )
}
